"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stepRoutes = void 0;
const stepActions_openapi_1 = require("./stepActions.openapi");
exports.stepRoutes = [
    {
        name: 'step.list',
        path: ['/', '/q/:q'],
        method: 'GET',
        plugins: {
            openapi: stepActions_openapi_1.stepOpenApiDocs['step.list']
        }
    },
    {
        name: 'step.create',
        path: ['/'],
        method: 'POST',
        plugins: {
            openapi: stepActions_openapi_1.stepOpenApiDocs['step.create']
        }
    },
    {
        name: 'step.get',
        path: '/:id',
        method: 'GET',
        plugins: {
            openapi: stepActions_openapi_1.stepOpenApiDocs['step.get']
        }
    },
    {
        name: 'step.update',
        path: '/:id',
        method: 'PUT',
        plugins: {
            openapi: stepActions_openapi_1.stepOpenApiDocs['step.update']
        }
    },
    {
        name: 'step.delete',
        path: '/:id',
        method: 'DELETE',
        plugins: {
            openapi: stepActions_openapi_1.stepOpenApiDocs['step.delete']
        }
    }
];
